export default __webpack_public_path__ + "media/images/preview-7c10a445d17271ea51c94ec301b3d124.png";